<template>
  <div class="skill">
    <div class="header">
      <template v-for="level in Object.keys(levelMap)">
        <div
          v-if="level"
          :key="level"
          class="item"
          :class="[activeLevel == level ? 'active' : '']"
          @click="handleTabsChange(level)"
        >
          <img :src="levelMap[level].icon" alt="" />
        </div>
        <div :key="level + 'd'" class="divider" v-if="level != 7"></div>
      </template>
    </div>
    <div class="base">
      <img class="icon" alt="" :src="dataSource.icon.value" />
      <div class="info">
        <div class="left">
          <div class="name">
            <span>技能：{{ dataSource.name.value }}</span>
          </div>
          <div class="attr">
            <img :src="dataSource.upgrade['level' + activeLevel].icon.value" alt="" />
            <span class="item">
              SP
              <span style="color: #FFBC5E;">{{ dataSource.upgrade["level" + activeLevel].sp.value }}</span>
            </span>
            <span class="item">
              CD
              <span style="color: #FFBC5E;"> {{ dataSource.upgrade["level" + activeLevel].cd.value }}</span>
            </span>
          </div>
        </div>
        <div class="right">
          <div class="video-btn" v-if="dataSource.video.hasValue && dataSource.video.value" @click="openVideo">
            技能动画
          </div>
        </div>
        <!-- 显示技能视频 -->
        <el-dialog
          title=""
          fullscreen
          append-to-body
          custom-class="video-dialog"
          :visible.sync="videoVisible"
          :after-close="closeVideo"
        >
          <div class="video-container">
            <!-- 判断是否需要实名认证 -->
            <template v-if="dataSource.video.isLimit">
              <span style="position: relative;">
                <video :poster="dataSource.video.value" controls autoplay muted></video>
                <LimitVideoTips style="position: absolute;bottom: 80px;left: 11px;" />
              </span>
            </template>
            <template v-else>
              <video :src="dataSource.video.value" controls autoplay muted></video>
            </template>
          </div>
        </el-dialog>
      </div>
    </div>
    <div class="desc">
      <span v-html="highlightNumbers(dataSource.upgrade['level' + activeLevel].desc.value)"></span>
    </div>
    <div class="effect">
      <div>
        <span>{{ dataSource.ability1.name.value }}</span
        >：<span class="effect-desc">{{ dataSource.ability1.desc.value }}</span>
      </div>
      <div>
        <span>{{ dataSource.ability2.name.value }}</span
        >：<span class="effect-desc">{{ dataSource.ability2.desc.value }}</span>
      </div>
    </div>
    <div class="other-attr">
      <div class="left">
        <div class="item">
          <img class="icon" alt="" :src="dataSource.attr1.icon.value" />
          <span>{{ dataSource.attr1.name.value }}</span>
        </div>
        <div class="item">
          <img class="icon" alt="" :src="dataSource.attr2.icon.value" />
          <span>{{ dataSource.attr2.name.value }}</span>
        </div>
        <div class="item">
          <img class="icon" alt="" :src="dataSource.upgrade['level' + activeLevel].icon.value" />
          <span>{{ dataSource.attr3.name.value }}</span>
        </div>
      </div>
      <div class="right"></div>
    </div>

    <div class="more-content">
      <div class="title">
        <img class="icon" src="@/assets/zs_imgs/skill-more-title-icon.png" alt="" />
        技能潜力
      </div>
      <div class="potential" v-if="!isEmptyPotential">
        <template v-for="key in Object.keys(dataSource.potential)">
          <div
            class="item"
            :key="key"
            v-if="dataSource.potential[key].icon.hasValue && dataSource.potential[key].icon.value"
          >
            <img class="icon" :src="dataSource.potential[key].icon.value" alt="" />
            <span class="desc" v-if="dataSource.potential[key].desc.value">{{
              dataSource.potential[key].desc.value
            }}</span>
            <img class="desc-icon" v-else :src="dataSource.potential[key].iconDesc.value" alt="" />
          </div>
        </template>
      </div>
    </div>
    <div class="divider"></div>
    <TalentSkill :dataSource="talentDataSource" />
  </div>
</template>

<script>
import TalentSkill from "./talentSkill.vue";
import LimitVideoTips from "@/views/wiki/tj/zs/components/LimitVideoTips.vue";

export default {
  components: { TalentSkill, LimitVideoTips },
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    talentDataSource: { type: Object, default: () => ({}) }
  },
  inject: {
    refreshMap: {
      default: () => {}
    }
  },
  data() {
    return {
      drawer: false,
      videoVisible: false,
      activeLevel: 6,
      levelMap: {
        1: {
          icon: require(`@/assets/zs_imgs/skill-icon-0.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-1-acitve.png`)
        },
        2: {
          icon: require(`@/assets/zs_imgs/skill-icon-1.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-1-acitve.png`)
        },
        3: {
          icon: require(`@/assets/zs_imgs/skill-icon-2.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-2-acitve.png`)
        },
        4: {
          icon: require(`@/assets/zs_imgs/skill-icon-3.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-3-acitve.png`)
        },
        5: {
          icon: require(`@/assets/zs_imgs/skill-icon-4.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-4-acitve.png`)
        },
        6: {
          icon: require(`@/assets/zs_imgs/skill-icon-5.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-5-acitve.png`)
        },
        7: {
          icon: require(`@/assets/zs_imgs/skill-icon-full.png`)
          // acitveIcon: require(`@/assets/zs_imgs/skill-icon-full-acitve.png`)
        }
      }
    };
  },
  computed: {
    isEmptyPotential() {
      return !Object.keys(this.dataSource.potential).some(key => {
        return this.dataSource.potential[key].icon.hasValue && this.dataSource.potential[key].icon.value;
      });
    }
  },
  methods: {
    handleTabsChange(level) {
      this.activeLevel = level;
    },
    openVideo() {
      this.videoVisible = true;
    },
    closeVideo() {
      this.videoVisible = false;
    },
    highlightNumbers(str) {
      return str.replace(/(\d+\.?\d*%?)/g, `<span style="color: #FFBC5E;">$1</span>`);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .video-dialog {
  background-color: rgba(0, 0, 0, 0.9);
  .el-dialog__header {
    padding: 0;
    position: relative;
    margin: 0 auto;
    width: 1000px;
    .el-dialog__headerbtn {
      z-index: 1;
      width: 37px;
      height: 37px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50%;
    }
    .el-icon-close {
      color: #fff;
    }
  }
  .el-dialog__body {
    padding: 0;
  }
  .video-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    overflow: hidden;
    video {
      width: 960px;
    }
  }
}
.skill {
  width: 100%;
  padding-left: 4px;
  margin-bottom: 50px;
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 24px;
    margin-bottom: 30px;
    .item {
      position: relative;
      width: 100%;
      height: 50px;
      cursor: pointer;
      text-align: center;
      img {
        width: 50px;
        height: 50px;
        opacity: 0.3;
      }
      &.active {
        img {
          opacity: 1;
        }
      }
    }
    // &::before,
    // &::after {
    //   content: "";
    //   display: inline-block;
    //   width: 1px;
    //   height: 24px;
    //   background: rgba(255, 255, 255, 0.08);
    // }
    .divider {
      width: 1px;
      height: 24px;
      background: rgba(255, 255, 255, 0.08);
    }
  }
  .base {
    display: flex;
    align-items: center;
    height: 48px;
    margin-bottom: 8px;
    .icon {
      flex-shrink: 0;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 19px;
    }

    .info {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;
      }
      .name {
        display: flex;
        align-items: center;
        font-family: Source Han Sans CN;
        font-weight: 600;
        font-size: 24px;
        color: #ffffff;
        line-height: 20px;
      }

      .attr {
        display: flex;
        align-items: center;
        margin-left: 16px;
        font-size: 16px;
        img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
        .item {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          line-height: 20px;
          margin-right: 20px;
        }
      }

      .video-btn {
        display: flex;
        align-items: center;
        gap: 9px;
        height: 22px;
        background: #e1dad5;
        border-radius: 11px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        line-height: 12px;
        color: #392e25;
        cursor: pointer;
        padding: 0 10px;
        &::before {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-top: 5px solid transparent;
          border-bottom: 5px solid transparent;
          border-left: 7px solid #000000;
          border-radius: 2px;
        }
      }
    }
  }

  & > .desc {
    font-weight: 400;
    font-size: 18px;
    color: #bbbbbb;
    line-height: 28px;
    margin-bottom: 10px;
  }

  .effect {
    margin-bottom: 24px;

    .effect-desc {
      color: #bbbbbb;
    }

    div {
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
      margin-bottom: 9px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .other-attr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .left {
      display: flex;
      gap: 53px;
    }
    .item {
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      gap: 11px;
      .icon {
        width: 42px;
        height: 42px;
      }
    }
  }

  .more-content {
    width: 100%;
    & > .title {
      position: relative;
      width: 160px;
      height: 20px;
      background: linear-gradient(90deg, rgba(34, 82, 100, 0.87) 21%, rgba(34, 82, 100, 0) 100%);
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 20px;
      margin-left: 10px;
      padding-left: 16px;
      &::before {
        content: "";
        display: inline-block;
        width: 32px;
        height: 32px;
        background: url("~@/assets/zs_imgs/skill-more-title-bg-icon.png") no-repeat;
        background-size: cover;
        position: absolute;
        left: -16px;
        top: -6px;
      }
      .icon {
        position: absolute;
        left: -12px;
        top: -3px;
        width: 24px;
        height: 24px;
        vertical-align: middle;
      }
    }

    .potential {
      width: 100%;
      margin-bottom: 20px;
      .item {
        display: flex;
        gap: 9px;
        align-items: center;
        margin-bottom: 11px;
        &:last-child {
          margin-bottom: 0;
        }
        .icon {
          width: 26px;
          height: 26px;
          background: #222337;
          border-radius: 4px;
          border: 1px solid #656f74;
        }
        .desc {
          font-weight: 400;
          font-size: 18px;
          color: #bbbbbb;
          line-height: 20px;
        }
        .desc-icon {
          width: 26px;
          height: 26px;
          border-radius: 4px;
        }
      }
    }
  }
  .divider {
    height: 1px;
    background-color: rgba(255, 255, 255, 0.1);
    margin-bottom: 20px;
  }
}
</style>
